import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-no-result-found',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './no-result-found.component.html',
  styleUrl: './no-result-found.component.scss'
})
export class NoResultFoundComponent {}
